/**
 * Owner: Masa Bayu
 * File: typography-font.ts
 * Date:Time: 2026-09-13 21:04
 * Description: 22B semantic font-family identity (no loading/CSS stacks).
 */
export const QX_FONT_FAMILY_KINDS = ['sans', 'serif', 'mono', 'display'];
const FORBIDDEN = [
    'css',
    'src',
    'url',
    'woff',
    'woff2',
    'ttf',
    'otf',
    'fontFace',
    'className',
    'style',
    'dom',
];
function assertNoForbidden(record, label) {
    for (const key of FORBIDDEN) {
        if (key in record) {
            throw new Error(`${label} must not include render field "${key}"`);
        }
    }
}
function assertId(value, label) {
    if (typeof value !== 'string' || value.trim().length === 0 || /\s/.test(value)) {
        throw new Error(`${label} must be a non-empty id without whitespace`);
    }
}
export function isQXFontFamilyKind(value) {
    return typeof value === 'string' && QX_FONT_FAMILY_KINDS.includes(value);
}
export function createQXFontFamily(options) {
    assertNoForbidden({ ...options }, 'Font family');
    assertId(options.id, 'Font family id');
    if (typeof options.name !== 'string' || options.name.trim().length === 0) {
        throw new Error('Font family name must be a non-empty string');
    }
    if (!isQXFontFamilyKind(options.kind)) {
        throw new Error(`Invalid font family kind: ${String(options.kind)}`);
    }
    return Object.freeze({
        id: options.id.trim(),
        name: options.name.trim(),
        kind: options.kind,
    });
}
export function isQXFontFamily(value) {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        return false;
    }
    const record = value;
    return (typeof record.id === 'string' &&
        typeof record.name === 'string' &&
        isQXFontFamilyKind(record.kind));
}
//# sourceMappingURL=typography-font.js.map